<template>
  <b-overlay :show="condition" variant="secondary" :opacity="0.9">
    <slot></slot>
    <template #overlay>
      <div class="text-center pt-2">
        <img
            v-if="displayLock"
          :src="require('@/assets/images/icons/lock_white@2x.png')"
          alt=""
          srcset=""
          :class="[ text == 'Base Discovery Miles' ?'smallen-image':'img-icon-lock pt-1']"

        />
        <p
          :class="[
            text == 'Base Discovery Miles' ? 'mt-0  mb-0' : 'mb-0',
            'text-white lock-font pt-2',
          ]"
        >
          {{ text }}
        </p>
        <p :class="['text-white smallen-font lock-font',  text == 'Base Discovery Miles' ? 'mt-0 mb-0' : 'mt-1',]">{{ subText }}</p>
      </div>
    </template>
  </b-overlay>
</template>

<script>
export default {
  props: {
    condition: {
      default: false,
    },
    displayLock : {
      default: true,
    },
    text: {
      default: "Locked",
    },
    subText: {
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
